import type { PetSpecies } from '../types';
import { palette5 } from '../utils/colorPalette';

function petDog(): string {
  const fur = palette5('#e8c094');
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.22)"/>
  <rect x="50" y="28" width="3" height="2" fill="${fur.deep}"/>
  <rect x="52" y="26" width="3" height="8" fill="${fur.shadow}"/>
  <rect x="53" y="26" width="2" height="8" fill="${fur.base}"/>
  <rect x="54" y="28" width="2" height="3" fill="${fur.light}"/>
  <rect x="14" y="28" width="32" height="2" fill="${fur.deep}"/>
  <rect x="12" y="30" width="36" height="20" fill="${fur.shadow}"/>
  <rect x="12" y="30" width="36" height="18" fill="${fur.base}"/>
  <rect x="12" y="30" width="36" height="2" fill="${fur.light}"/>
  <rect x="14" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="15" y="48" width="5" height="6" fill="${fur.base}"/>
  <rect x="26" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="27" y="48" width="5" height="6" fill="${fur.base}"/>
  <rect x="40" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="41" y="48" width="5" height="6" fill="${fur.base}"/>
  <rect x="8" y="12" width="30" height="2" fill="${fur.deep}"/>
  <rect x="6" y="14" width="34" height="20" fill="${fur.shadow}"/>
  <rect x="6" y="14" width="34" height="18" fill="${fur.base}"/>
  <rect x="6" y="14" width="34" height="2" fill="${fur.light}"/>
  <rect x="2" y="6" width="6" height="2" fill="${fur.deep}"/>
  <rect x="2" y="8" width="8" height="14" fill="${fur.shadow}"/>
  <rect x="3" y="8" width="6" height="14" fill="${fur.base}"/>
  <rect x="34" y="6" width="8" height="2" fill="${fur.deep}"/>
  <rect x="34" y="8" width="10" height="14" fill="${fur.shadow}"/>
  <rect x="34" y="8" width="9" height="14" fill="${fur.base}"/>
  <rect x="13" y="20" width="4" height="5" fill="#fff"/>
  <rect x="14" y="22" width="2" height="2" fill="#000"/>
  <rect x="29" y="20" width="4" height="5" fill="#fff"/>
  <rect x="30" y="22" width="2" height="2" fill="#000"/>
  <rect x="20" y="24" width="6" height="3" fill="#1a1a1a"/>
  <rect x="22" y="29" width="2" height="2" fill="#ff7fa8"/>
  <rect x="8" y="24" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
  <rect x="35" y="24" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
</svg>`;
}

function petCat(): string {
  const fur = palette5('#f5f0e8');
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.22)"/>
  <rect x="48" y="22" width="2" height="20" fill="${fur.shadow}"/>
  <rect x="50" y="20" width="2" height="14" fill="${fur.base}"/>
  <rect x="52" y="18" width="2" height="8" fill="${fur.base}"/>
  <rect x="14" y="28" width="32" height="2" fill="${fur.deep}"/>
  <rect x="12" y="30" width="36" height="20" fill="${fur.shadow}"/>
  <rect x="12" y="30" width="36" height="18" fill="${fur.base}"/>
  <rect x="12" y="30" width="36" height="2" fill="${fur.light}"/>
  <rect x="14" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="15" y="48" width="5" height="6" fill="${fur.base}"/>
  <rect x="26" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="27" y="48" width="5" height="6" fill="${fur.base}"/>
  <rect x="40" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="41" y="48" width="5" height="6" fill="${fur.base}"/>
  <rect x="8" y="12" width="30" height="2" fill="${fur.deep}"/>
  <rect x="6" y="14" width="34" height="20" fill="${fur.shadow}"/>
  <rect x="6" y="14" width="34" height="18" fill="${fur.base}"/>
  <rect x="6" y="14" width="34" height="2" fill="${fur.light}"/>
  <!-- 고양이 귀 (삼각) -->
  <rect x="6" y="6" width="2" height="8" fill="${fur.deep}"/>
  <rect x="8" y="8" width="2" height="6" fill="${fur.shadow}"/>
  <rect x="10" y="10" width="2" height="4" fill="${fur.base}"/>
  <rect x="36" y="6" width="2" height="8" fill="${fur.deep}"/>
  <rect x="34" y="8" width="2" height="6" fill="${fur.shadow}"/>
  <rect x="32" y="10" width="2" height="4" fill="${fur.base}"/>
  <!-- 눈 (고양이 — 세로 동공) -->
  <rect x="13" y="19" width="4" height="6" fill="#a4d54a"/>
  <rect x="14" y="20" width="1" height="4" fill="#000"/>
  <rect x="29" y="19" width="4" height="6" fill="#a4d54a"/>
  <rect x="30" y="20" width="1" height="4" fill="#000"/>
  <!-- 코 (작음) -->
  <rect x="22" y="25" width="4" height="2" fill="#ff9bc0"/>
  <!-- 입 -->
  <rect x="22" y="27" width="1" height="2" fill="#1a1a1a"/>
  <rect x="25" y="27" width="1" height="2" fill="#1a1a1a"/>
  <!-- 수염 -->
  <rect x="2" y="24" width="8" height="1" fill="#fff" opacity="0.6"/>
  <rect x="38" y="24" width="8" height="1" fill="#fff" opacity="0.6"/>
</svg>`;
}

function petRabbit(): string {
  const fur = palette5('#ffd6e8');
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.22)"/>
  <rect x="14" y="30" width="32" height="20" fill="${fur.shadow}"/>
  <rect x="14" y="30" width="32" height="18" fill="${fur.base}"/>
  <rect x="14" y="30" width="32" height="2" fill="${fur.light}"/>
  <!-- 다리 -->
  <rect x="16" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="17" y="48" width="5" height="6" fill="${fur.base}"/>
  <rect x="40" y="48" width="7" height="6" fill="${fur.shadow}"/>
  <rect x="41" y="48" width="5" height="6" fill="${fur.base}"/>
  <!-- 머리 (큼) -->
  <rect x="10" y="14" width="30" height="20" fill="${fur.shadow}"/>
  <rect x="10" y="14" width="30" height="18" fill="${fur.base}"/>
  <rect x="10" y="14" width="30" height="2" fill="${fur.light}"/>
  <!-- 토끼 귀 (긴) -->
  <rect x="12" y="0" width="6" height="16" fill="${fur.shadow}"/>
  <rect x="13" y="0" width="4" height="14" fill="${fur.base}"/>
  <rect x="14" y="2" width="2" height="6" fill="${fur.light}"/>
  <rect x="32" y="0" width="6" height="16" fill="${fur.shadow}"/>
  <rect x="33" y="0" width="4" height="14" fill="${fur.base}"/>
  <rect x="34" y="2" width="2" height="6" fill="${fur.light}"/>
  <!-- 눈 -->
  <rect x="15" y="22" width="4" height="5" fill="#000"/>
  <rect x="16" y="23" width="2" height="2" fill="#fff"/>
  <rect x="31" y="22" width="4" height="5" fill="#000"/>
  <rect x="32" y="23" width="2" height="2" fill="#fff"/>
  <!-- 코 -->
  <rect x="23" y="28" width="4" height="2" fill="#ff5a8a"/>
  <!-- 입 (Y자) -->
  <rect x="25" y="30" width="2" height="2" fill="#1a1a1a"/>
  <rect x="22" y="31" width="2" height="1" fill="#1a1a1a"/>
  <rect x="28" y="31" width="2" height="1" fill="#1a1a1a"/>
  <!-- 볼터치 -->
  <rect x="11" y="26" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
  <rect x="36" y="26" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
</svg>`;
}

function petHamster(): string {
  const fur = palette5('#ffd95c');
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="16" ry="2" fill="rgba(0,0,0,0.22)"/>
  <!-- 둥근 몸 -->
  <rect x="12" y="22" width="40" height="30" fill="${fur.shadow}"/>
  <rect x="12" y="22" width="40" height="28" fill="${fur.base}"/>
  <rect x="12" y="22" width="40" height="2" fill="${fur.light}"/>
  <rect x="14" y="50" width="36" height="2" fill="${fur.deep}"/>
  <!-- 작은 다리 -->
  <rect x="16" y="50" width="6" height="4" fill="${fur.shadow}"/>
  <rect x="42" y="50" width="6" height="4" fill="${fur.shadow}"/>
  <!-- 작은 귀 -->
  <rect x="14" y="18" width="6" height="6" fill="${fur.deep}"/>
  <rect x="15" y="19" width="4" height="4" fill="${fur.base}"/>
  <rect x="44" y="18" width="6" height="6" fill="${fur.deep}"/>
  <rect x="45" y="19" width="4" height="4" fill="${fur.base}"/>
  <!-- 눈 -->
  <rect x="20" y="30" width="4" height="5" fill="#000"/>
  <rect x="21" y="31" width="1" height="1" fill="#fff"/>
  <rect x="40" y="30" width="4" height="5" fill="#000"/>
  <rect x="41" y="31" width="1" height="1" fill="#fff"/>
  <!-- 코 -->
  <rect x="30" y="36" width="4" height="2" fill="#1a1a1a"/>
  <!-- 입 -->
  <rect x="29" y="38" width="2" height="2" fill="#1a1a1a"/>
  <rect x="33" y="38" width="2" height="2" fill="#1a1a1a"/>
  <!-- 통통한 볼 -->
  <rect x="14" y="36" width="6" height="6" fill="${fur.light}"/>
  <rect x="44" y="36" width="6" height="6" fill="${fur.light}"/>
</svg>`;
}

function petDragon(): string {
  const fur = palette5('#e8324a');
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <!-- 반짝이 (legendary) -->
  <circle cx="6" cy="10" r="1.5" fill="#ffd95c" opacity="0.9">
    <animate attributeName="opacity" values="0;0.9;0" dur="1.8s" repeatCount="indefinite"/>
  </circle>
  <circle cx="58" cy="14" r="1.5" fill="#fff8d8" opacity="0.9">
    <animate attributeName="opacity" values="0;0.9;0" dur="2s" begin="0.5s" repeatCount="indefinite"/>
  </circle>
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.3)"/>
  <!-- 꼬리 -->
  <rect x="50" y="36" width="4" height="4" fill="${fur.deep}"/>
  <rect x="52" y="32" width="4" height="8" fill="${fur.shadow}"/>
  <rect x="54" y="28" width="4" height="6" fill="${fur.base}"/>
  <!-- 몸 -->
  <rect x="14" y="28" width="32" height="22" fill="${fur.shadow}"/>
  <rect x="14" y="28" width="32" height="20" fill="${fur.base}"/>
  <rect x="14" y="28" width="32" height="2" fill="${fur.light}"/>
  <!-- 다리 (4개) -->
  <rect x="14" y="48" width="6" height="6" fill="${fur.deep}"/>
  <rect x="22" y="48" width="6" height="6" fill="${fur.deep}"/>
  <rect x="32" y="48" width="6" height="6" fill="${fur.deep}"/>
  <rect x="40" y="48" width="6" height="6" fill="${fur.deep}"/>
  <!-- 머리 -->
  <rect x="6" y="12" width="28" height="20" fill="${fur.shadow}"/>
  <rect x="6" y="12" width="28" height="18" fill="${fur.base}"/>
  <rect x="6" y="12" width="28" height="2" fill="${fur.light}"/>
  <!-- 뿔 (양쪽) -->
  <rect x="8" y="6" width="3" height="6" fill="${fur.rim}"/>
  <rect x="9" y="4" width="2" height="3" fill="${fur.rim}"/>
  <rect x="28" y="6" width="3" height="6" fill="${fur.rim}"/>
  <rect x="29" y="4" width="2" height="3" fill="${fur.rim}"/>
  <!-- 눈 (노란) -->
  <rect x="11" y="18" width="4" height="5" fill="#ffd95c"/>
  <rect x="12" y="19" width="1" height="3" fill="#000"/>
  <rect x="25" y="18" width="4" height="5" fill="#ffd95c"/>
  <rect x="26" y="19" width="1" height="3" fill="#000"/>
  <!-- 콧구멍 -->
  <rect x="6" y="24" width="2" height="2" fill="#000"/>
  <rect x="6" y="27" width="2" height="2" fill="#000"/>
  <!-- 이빨 -->
  <rect x="10" y="28" width="2" height="3" fill="#fff"/>
  <rect x="14" y="28" width="2" height="3" fill="#fff"/>
  <!-- 등 가시 (3개) -->
  <rect x="20" y="24" width="3" height="4" fill="${fur.deep}"/>
  <rect x="28" y="22" width="3" height="6" fill="${fur.deep}"/>
  <rect x="36" y="24" width="3" height="4" fill="${fur.deep}"/>
</svg>`;
}

// ── NEW SPECIES ────────────────────────────────────────────────────────────

function petBird(): string {
  const body = palette5('#f5e84a');   // 노란 잉꼬
  const wing = palette5('#7bcf52');   // 초록 날개
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="14" ry="2" fill="rgba(0,0,0,0.2)"/>
  <!-- 꼬리 깃 -->
  <rect x="42" y="38" width="4" height="14" fill="${wing.shadow}"/>
  <rect x="46" y="36" width="4" height="10" fill="${wing.base}"/>
  <rect x="50" y="34" width="3" height="8"  fill="${wing.light}"/>
  <!-- 몸통 -->
  <rect x="18" y="26" width="28" height="22" fill="${body.shadow}"/>
  <rect x="18" y="26" width="28" height="20" fill="${body.base}"/>
  <rect x="18" y="26" width="28" height="3"  fill="${body.light}"/>
  <!-- 배 (흰) -->
  <rect x="24" y="32" width="14" height="12" fill="#fffde8"/>
  <!-- 날개 (좌) -->
  <rect x="10" y="28" width="10" height="16" fill="${wing.shadow}"/>
  <rect x="11" y="28" width="8"  height="14" fill="${wing.base}"/>
  <rect x="12" y="28" width="6"  height="4"  fill="${wing.light}"/>
  <!-- 날개 (우) — 접힘 -->
  <rect x="44" y="28" width="8" height="12" fill="${wing.shadow}"/>
  <rect x="45" y="28" width="6" height="10" fill="${wing.base}"/>
  <!-- 발 (얇은 막대) -->
  <rect x="26" y="48" width="3" height="6" fill="#e8a020"/>
  <rect x="35" y="48" width="3" height="6" fill="#e8a020"/>
  <rect x="24" y="52" width="7" height="2" fill="#e8a020"/>
  <rect x="33" y="52" width="7" height="2" fill="#e8a020"/>
  <!-- 머리 -->
  <rect x="12" y="8" width="26" height="20" fill="${body.shadow}"/>
  <rect x="12" y="8" width="26" height="18" fill="${body.base}"/>
  <rect x="12" y="8" width="26" height="2"  fill="${body.light}"/>
  <!-- 이마 초록 무늬 -->
  <rect x="16" y="10" width="8" height="4" fill="${wing.base}"/>
  <rect x="16" y="10" width="8" height="2" fill="${wing.light}"/>
  <!-- 눈 (흰 바탕 + 검정 동공) -->
  <rect x="16" y="16" width="5" height="5" fill="#fff"/>
  <rect x="17" y="17" width="2" height="2" fill="#000"/>
  <rect x="29" y="16" width="5" height="5" fill="#fff"/>
  <rect x="30" y="17" width="2" height="2" fill="#000"/>
  <!-- 부리 (삼각 — 주황) -->
  <rect x="22" y="22" width="6" height="3" fill="#e8a020"/>
  <rect x="23" y="24" width="4" height="2" fill="#c87000"/>
  <!-- 볼터치 -->
  <rect x="13" y="20" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
  <rect x="34" y="20" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
</svg>`;
}

function petUnicorn(): string {
  const body = palette5('#f8f0ff');   // 흰색 말
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <!-- legend sparkle rings -->
  <circle cx="4"  cy="8"  r="1.5" fill="#ffd95c" opacity="0.9">
    <animate attributeName="opacity" values="0;1;0" dur="1.6s" repeatCount="indefinite"/>
  </circle>
  <circle cx="60" cy="10" r="1.5" fill="#c878ff" opacity="0.9">
    <animate attributeName="opacity" values="0;1;0" dur="2.1s" begin="0.4s" repeatCount="indefinite"/>
  </circle>
  <circle cx="58" cy="42" r="1"   fill="#7fecff" opacity="0.9">
    <animate attributeName="opacity" values="0;1;0" dur="1.9s" begin="0.9s" repeatCount="indefinite"/>
  </circle>
  <circle cx="5"  cy="44" r="1"   fill="#ff9ff0" opacity="0.9">
    <animate attributeName="opacity" values="0;1;0" dur="2.3s" begin="1.2s" repeatCount="indefinite"/>
  </circle>
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.2)"/>
  <!-- 꼬리 (무지개) -->
  <rect x="48" y="28" width="4" height="20" fill="#ff7fce"/>
  <rect x="50" y="26" width="4" height="20" fill="#a87fff"/>
  <rect x="52" y="24" width="3" height="18" fill="#7fd4ff"/>
  <!-- 몸 -->
  <rect x="12" y="28" width="38" height="22" fill="${body.shadow}"/>
  <rect x="12" y="28" width="38" height="20" fill="${body.base}"/>
  <rect x="12" y="28" width="38" height="2"  fill="${body.light}"/>
  <!-- 다리 (4개, 가늘고 우아) -->
  <rect x="14" y="48" width="5" height="6" fill="${body.shadow}"/>
  <rect x="21" y="48" width="5" height="6" fill="${body.shadow}"/>
  <rect x="33" y="48" width="5" height="6" fill="${body.shadow}"/>
  <rect x="40" y="48" width="5" height="6" fill="${body.shadow}"/>
  <!-- 굽 (금) -->
  <rect x="14" y="52" width="5" height="2" fill="#d4a820"/>
  <rect x="21" y="52" width="5" height="2" fill="#d4a820"/>
  <rect x="33" y="52" width="5" height="2" fill="#d4a820"/>
  <rect x="40" y="52" width="5" height="2" fill="#d4a820"/>
  <!-- 머리 -->
  <rect x="6" y="10" width="26" height="20" fill="${body.shadow}"/>
  <rect x="6" y="10" width="26" height="18" fill="${body.base}"/>
  <rect x="6" y="10" width="26" height="2"  fill="${body.light}"/>
  <!-- 황금 뿔 -->
  <rect x="20" y="0" width="3" height="12" fill="#d4a820"/>
  <rect x="21" y="0" width="2" height="10" fill="#ffe070"/>
  <!-- 갈기 (무지개) -->
  <rect x="26" y="8"  width="6" height="16" fill="#ff7fce"/>
  <rect x="30" y="6"  width="6" height="18" fill="#a87fff"/>
  <rect x="34" y="8"  width="5" height="14" fill="#7fd4ff"/>
  <!-- 눈 (보라빛) -->
  <rect x="10" y="16" width="5" height="5" fill="#fff"/>
  <rect x="11" y="17" width="2" height="2" fill="#8840ff"/>
  <rect x="12" y="17" width="1" height="1" fill="#fff"/>
  <rect x="22" y="16" width="5" height="5" fill="#fff"/>
  <rect x="23" y="17" width="2" height="2" fill="#8840ff"/>
  <rect x="24" y="17" width="1" height="1" fill="#fff"/>
  <!-- 코 -->
  <rect x="8"  y="24" width="4" height="2" fill="#ffabd0"/>
  <!-- 볼터치 (분홍) -->
  <rect x="7"  y="22" width="3" height="2" fill="#ff9fce" opacity="0.8"/>
  <rect x="27" y="22" width="3" height="2" fill="#ff9fce" opacity="0.8"/>
</svg>`;
}

function petPenguin(): string {
  const black = palette5('#1e2236');   // 몸 검정
  const white = palette5('#f0f4ff');   // 배 흰색
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="15" ry="2" fill="rgba(0,0,0,0.25)"/>
  <!-- 몸 (검정) -->
  <rect x="16" y="22" width="32" height="28" fill="${black.shadow}"/>
  <rect x="16" y="22" width="32" height="26" fill="${black.base}"/>
  <rect x="16" y="22" width="32" height="2"  fill="${black.light}"/>
  <!-- 배 (흰) -->
  <rect x="22" y="26" width="20" height="20" fill="${white.shadow}"/>
  <rect x="22" y="26" width="20" height="18" fill="${white.base}"/>
  <rect x="22" y="26" width="20" height="2"  fill="${white.light}"/>
  <!-- 날개 (좌우 — 납작) -->
  <rect x="8"  y="24" width="10" height="18" fill="${black.shadow}"/>
  <rect x="9"  y="24" width="8"  height="16" fill="${black.base}"/>
  <rect x="46" y="24" width="10" height="18" fill="${black.shadow}"/>
  <rect x="47" y="24" width="8"  height="16" fill="${black.base}"/>
  <!-- 발 (주황) -->
  <rect x="22" y="50" width="8" height="4" fill="#e88020"/>
  <rect x="34" y="50" width="8" height="4" fill="#e88020"/>
  <rect x="20" y="52" width="10" height="2" fill="#c86000"/>
  <rect x="34" y="52" width="10" height="2" fill="#c86000"/>
  <!-- 머리 (검정) -->
  <rect x="14" y="6" width="28" height="18" fill="${black.shadow}"/>
  <rect x="14" y="6" width="28" height="16" fill="${black.base}"/>
  <rect x="14" y="6" width="28" height="2"  fill="${black.light}"/>
  <!-- 얼굴 흰 테두리 -->
  <rect x="18" y="10" width="18" height="12" fill="${white.base}"/>
  <!-- 눈 -->
  <rect x="19" y="12" width="5" height="5" fill="#fff"/>
  <rect x="20" y="13" width="2" height="2" fill="#000"/>
  <rect x="21" y="13" width="1" height="1" fill="#fff"/>
  <rect x="32" y="12" width="5" height="5" fill="#fff"/>
  <rect x="33" y="13" width="2" height="2" fill="#000"/>
  <rect x="34" y="13" width="1" height="1" fill="#fff"/>
  <!-- 부리 (주황 삼각) -->
  <rect x="25" y="19" width="6" height="3" fill="#e88020"/>
  <rect x="26" y="21" width="4" height="2" fill="#c86000"/>
  <!-- 볼터치 -->
  <rect x="18" y="18" width="3" height="2" fill="#ffabc0" opacity="0.6"/>
  <rect x="35" y="18" width="3" height="2" fill="#ffabc0" opacity="0.6"/>
</svg>`;
}

function petFox(): string {
  const fox  = palette5('#e86028');   // 주황 여우
  const belly = palette5('#f8f0e0');  // 흰 배
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.22)"/>
  <!-- 꼬리 (복슬) -->
  <rect x="46" y="30" width="8" height="18" fill="${fox.shadow}"/>
  <rect x="48" y="28" width="8" height="16" fill="${fox.base}"/>
  <rect x="50" y="28" width="6" height="14" fill="${fox.light}"/>
  <!-- 꼬리 흰 끝 -->
  <rect x="50" y="42" width="6" height="6" fill="${belly.base}"/>
  <rect x="51" y="44" width="4" height="4" fill="${belly.light}"/>
  <!-- 몸 -->
  <rect x="12" y="28" width="36" height="22" fill="${fox.shadow}"/>
  <rect x="12" y="28" width="36" height="20" fill="${fox.base}"/>
  <rect x="12" y="28" width="36" height="2"  fill="${fox.light}"/>
  <!-- 배 (흰) -->
  <rect x="20" y="32" width="18" height="14" fill="${belly.shadow}"/>
  <rect x="20" y="32" width="18" height="12" fill="${belly.base}"/>
  <!-- 다리 -->
  <rect x="14" y="48" width="7" height="6" fill="${fox.shadow}"/>
  <rect x="15" y="48" width="5" height="6" fill="${fox.base}"/>
  <rect x="28" y="48" width="7" height="6" fill="${fox.shadow}"/>
  <rect x="29" y="48" width="5" height="6" fill="${fox.base}"/>
  <!-- 머리 -->
  <rect x="6" y="10" width="30" height="20" fill="${fox.shadow}"/>
  <rect x="6" y="10" width="30" height="18" fill="${fox.base}"/>
  <rect x="6" y="10" width="30" height="2"  fill="${fox.light}"/>
  <!-- 뾰족한 귀 (삼각) -->
  <rect x="6"  y="2"  width="4" height="10" fill="${fox.deep}"/>
  <rect x="8"  y="4"  width="4" height="8"  fill="${fox.shadow}"/>
  <rect x="10" y="6"  width="2" height="4"  fill="${fox.base}"/>
  <rect x="28" y="2"  width="4" height="10" fill="${fox.deep}"/>
  <rect x="28" y="4"  width="4" height="8"  fill="${fox.shadow}"/>
  <rect x="30" y="6"  width="2" height="4"  fill="${fox.base}"/>
  <!-- 귀 안쪽 (분홍) -->
  <rect x="9"  y="5"  width="2" height="4"  fill="#ffb0a0"/>
  <rect x="29" y="5"  width="2" height="4"  fill="#ffb0a0"/>
  <!-- 얼굴 흰 영역 -->
  <rect x="10" y="18" width="16" height="10" fill="${belly.base}"/>
  <!-- 눈 -->
  <rect x="10" y="16" width="4" height="5" fill="#fff"/>
  <rect x="11" y="17" width="2" height="2" fill="#1a1000"/>
  <rect x="12" y="17" width="1" height="1" fill="#fff"/>
  <rect x="26" y="16" width="4" height="5" fill="#fff"/>
  <rect x="27" y="17" width="2" height="2" fill="#1a1000"/>
  <rect x="28" y="17" width="1" height="1" fill="#fff"/>
  <!-- 코 (검은 역삼각) -->
  <rect x="18" y="23" width="6" height="3" fill="#1a1a1a"/>
  <rect x="19" y="25" width="4" height="2" fill="#3a2020"/>
  <!-- 볼터치 -->
  <rect x="8"  y="22" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
  <rect x="30" y="22" width="3" height="2" fill="#ffabc0" opacity="0.7"/>
  <!-- 수염 -->
  <rect x="2"  y="23" width="7" height="1" fill="#fff" opacity="0.5"/>
  <rect x="32" y="23" width="7" height="1" fill="#fff" opacity="0.5"/>
</svg>`;
}

function petPanda(): string {
  const white = palette5('#f0f4f0');   // 흰 몸
  const black = palette5('#242428');   // 검정 패치
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.22)"/>
  <!-- 몸 (흰) -->
  <rect x="12" y="26" width="38" height="26" fill="${white.shadow}"/>
  <rect x="12" y="26" width="38" height="24" fill="${white.base}"/>
  <rect x="12" y="26" width="38" height="2"  fill="${white.light}"/>
  <!-- 다리 (검정) -->
  <rect x="14" y="48" width="8" height="6" fill="${black.base}"/>
  <rect x="40" y="48" width="8" height="6" fill="${black.base}"/>
  <!-- 팔 (검정) -->
  <rect x="6"  y="28" width="8" height="14" fill="${black.shadow}"/>
  <rect x="7"  y="28" width="6" height="12" fill="${black.base}"/>
  <rect x="48" y="28" width="8" height="14" fill="${black.shadow}"/>
  <rect x="49" y="28" width="6" height="12" fill="${black.base}"/>
  <!-- 머리 (큰 둥근 흰) -->
  <rect x="10" y="8" width="34" height="22" fill="${white.shadow}"/>
  <rect x="10" y="8" width="34" height="20" fill="${white.base}"/>
  <rect x="10" y="8" width="34" height="2"  fill="${white.light}"/>
  <!-- 둥근 귀 (검정) -->
  <rect x="10" y="4" width="10" height="8" fill="${black.base}"/>
  <rect x="34" y="4" width="10" height="8" fill="${black.base}"/>
  <!-- 눈 패치 (검정 큰) -->
  <rect x="12" y="14" width="10" height="8" fill="${black.shadow}"/>
  <rect x="13" y="15" width="8"  height="6" fill="${black.base}"/>
  <!-- 눈 흰 + 동공 -->
  <rect x="14" y="16" width="4" height="4" fill="#fff"/>
  <rect x="15" y="17" width="2" height="2" fill="#000"/>
  <rect x="16" y="17" width="1" height="1" fill="#fff"/>
  <rect x="30" y="14" width="10" height="8" fill="${black.shadow}"/>
  <rect x="31" y="15" width="8"  height="6" fill="${black.base}"/>
  <rect x="32" y="16" width="4" height="4" fill="#fff"/>
  <rect x="33" y="17" width="2" height="2" fill="#000"/>
  <rect x="34" y="17" width="1" height="1" fill="#fff"/>
  <!-- 코 (작은 검정) -->
  <rect x="25" y="23" width="4" height="2" fill="${black.base}"/>
  <!-- 입 -->
  <rect x="24" y="25" width="2" height="2" fill="${black.base}"/>
  <rect x="28" y="25" width="2" height="2" fill="${black.base}"/>
  <!-- 볼터치 -->
  <rect x="12" y="24" width="4" height="2" fill="#ffabc0" opacity="0.7"/>
  <rect x="38" y="24" width="4" height="2" fill="#ffabc0" opacity="0.7"/>
</svg>`;
}

function petBear(): string {
  const fur = palette5('#b87840');   // 갈색 곰
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.22)"/>
  <!-- 몸 (통통 둥근) -->
  <rect x="10" y="26" width="42" height="26" fill="${fur.shadow}"/>
  <rect x="10" y="26" width="42" height="24" fill="${fur.base}"/>
  <rect x="10" y="26" width="42" height="2"  fill="${fur.light}"/>
  <!-- 배 (밝은 원형) -->
  <rect x="18" y="30" width="22" height="18" fill="${fur.light}"/>
  <rect x="20" y="32" width="18" height="14" fill="${fur.rim}"/>
  <!-- 다리 (통통) -->
  <rect x="14" y="48" width="10" height="6" fill="${fur.shadow}"/>
  <rect x="15" y="48" width="8"  height="6" fill="${fur.base}"/>
  <rect x="38" y="48" width="10" height="6" fill="${fur.shadow}"/>
  <rect x="39" y="48" width="8"  height="6" fill="${fur.base}"/>
  <!-- 팔 -->
  <rect x="4"  y="28" width="8" height="16" fill="${fur.shadow}"/>
  <rect x="5"  y="28" width="6" height="14" fill="${fur.base}"/>
  <rect x="50" y="28" width="8" height="16" fill="${fur.shadow}"/>
  <rect x="51" y="28" width="6" height="14" fill="${fur.base}"/>
  <!-- 머리 (크고 둥근) -->
  <rect x="10" y="8" width="34" height="22" fill="${fur.shadow}"/>
  <rect x="10" y="8" width="34" height="20" fill="${fur.base}"/>
  <rect x="10" y="8" width="34" height="2"  fill="${fur.light}"/>
  <!-- 둥근 귀 -->
  <rect x="10" y="4" width="10" height="8" fill="${fur.shadow}"/>
  <rect x="11" y="5" width="8"  height="6" fill="${fur.base}"/>
  <rect x="34" y="4" width="10" height="8" fill="${fur.shadow}"/>
  <rect x="35" y="5" width="8"  height="6" fill="${fur.base}"/>
  <!-- 귀 안쪽 -->
  <rect x="13" y="6" width="4" height="4" fill="#d09060"/>
  <rect x="37" y="6" width="4" height="4" fill="#d09060"/>
  <!-- 눈 -->
  <rect x="16" y="16" width="5" height="5" fill="#fff"/>
  <rect x="17" y="17" width="2" height="2" fill="#2a1a00"/>
  <rect x="18" y="17" width="1" height="1" fill="#fff"/>
  <rect x="33" y="16" width="5" height="5" fill="#fff"/>
  <rect x="34" y="17" width="2" height="2" fill="#2a1a00"/>
  <rect x="35" y="17" width="1" height="1" fill="#fff"/>
  <!-- 주둥이 (동그란) -->
  <rect x="22" y="22" width="10" height="6" fill="${fur.light}"/>
  <rect x="23" y="23" width="8"  height="4" fill="${fur.rim}"/>
  <!-- 코 -->
  <rect x="25" y="22" width="4" height="2" fill="#2a1a00"/>
  <!-- 입 -->
  <rect x="24" y="26" width="2" height="2" fill="#2a1a00"/>
  <rect x="28" y="26" width="2" height="2" fill="#2a1a00"/>
  <!-- 볼터치 -->
  <rect x="13" y="24" width="4" height="2" fill="#ffabc0" opacity="0.7"/>
  <rect x="37" y="24" width="4" height="2" fill="#ffabc0" opacity="0.7"/>
</svg>`;
}

function petPig(): string {
  const fur = palette5('#f0a0b8');   // 분홍 돼지
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.22)"/>
  <!-- 꼬리 (말린) -->
  <rect x="50" y="28" width="4" height="4" fill="${fur.shadow}"/>
  <rect x="52" y="30" width="4" height="4" fill="${fur.base}"/>
  <rect x="54" y="32" width="2" height="2" fill="${fur.shadow}"/>
  <!-- 몸 (통통) -->
  <rect x="10" y="26" width="42" height="26" fill="${fur.shadow}"/>
  <rect x="10" y="26" width="42" height="24" fill="${fur.base}"/>
  <rect x="10" y="26" width="42" height="2"  fill="${fur.light}"/>
  <!-- 다리 (짧고 통통) -->
  <rect x="14" y="48" width="8" height="6" fill="${fur.shadow}"/>
  <rect x="15" y="48" width="6" height="6" fill="${fur.base}"/>
  <rect x="28" y="48" width="8" height="6" fill="${fur.shadow}"/>
  <rect x="29" y="48" width="6" height="6" fill="${fur.base}"/>
  <rect x="38" y="48" width="8" height="6" fill="${fur.shadow}"/>
  <rect x="39" y="48" width="6" height="6" fill="${fur.base}"/>
  <!-- 머리 (큰 동그란) -->
  <rect x="8" y="8" width="36" height="22" fill="${fur.shadow}"/>
  <rect x="8" y="8" width="36" height="20" fill="${fur.base}"/>
  <rect x="8" y="8" width="36" height="2"  fill="${fur.light}"/>
  <!-- 둥근 귀 -->
  <rect x="8"  y="4" width="10" height="8" fill="${fur.shadow}"/>
  <rect x="9"  y="5" width="8"  height="6" fill="${fur.base}"/>
  <rect x="34" y="4" width="10" height="8" fill="${fur.shadow}"/>
  <rect x="35" y="5" width="8"  height="6" fill="${fur.base}"/>
  <!-- 귀 안쪽 -->
  <rect x="11" y="6" width="4" height="4" fill="#ff88a8"/>
  <rect x="37" y="6" width="4" height="4" fill="#ff88a8"/>
  <!-- 눈 -->
  <rect x="14" y="14" width="5" height="5" fill="#fff"/>
  <rect x="15" y="15" width="2" height="2" fill="#2a1a2a"/>
  <rect x="16" y="15" width="1" height="1" fill="#fff"/>
  <rect x="33" y="14" width="5" height="5" fill="#fff"/>
  <rect x="34" y="15" width="2" height="2" fill="#2a1a2a"/>
  <rect x="35" y="15" width="1" height="1" fill="#fff"/>
  <!-- 주둥이 (크고 넓적) -->
  <rect x="16" y="22" width="20" height="8" fill="${fur.shadow}"/>
  <rect x="17" y="23" width="18" height="6" fill="#f0b8c8"/>
  <!-- 콧구멍 (2개 원) -->
  <rect x="20" y="24" width="4" height="3" fill="#d06080"/>
  <rect x="28" y="24" width="4" height="3" fill="#d06080"/>
  <!-- 볼터치 -->
  <rect x="10" y="20" width="4" height="3" fill="#ffabc0" opacity="0.8"/>
  <rect x="38" y="20" width="4" height="3" fill="#ffabc0" opacity="0.8"/>
</svg>`;
}

function petTurtle(): string {
  const shell = palette5('#5a9040');   // 초록 등껍질
  const skin  = palette5('#78b858');   // 밝은 녹색 몸
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="18" ry="2.5" fill="rgba(0,0,0,0.25)"/>
  <!-- 등껍질 (큰 돔) -->
  <rect x="12" y="16" width="40" height="28" fill="${shell.shadow}"/>
  <rect x="12" y="16" width="40" height="26" fill="${shell.base}"/>
  <rect x="12" y="16" width="40" height="4"  fill="${shell.light}"/>
  <!-- 껍질 무늬 (격자) -->
  <rect x="20" y="18" width="8"  height="10" fill="${shell.shadow}"/>
  <rect x="30" y="18" width="8"  height="10" fill="${shell.shadow}"/>
  <rect x="24" y="28" width="8"  height="10" fill="${shell.shadow}"/>
  <rect x="14" y="28" width="8"  height="10" fill="${shell.shadow}"/>
  <rect x="34" y="28" width="8"  height="10" fill="${shell.shadow}"/>
  <!-- 테두리 선 -->
  <rect x="20" y="18" width="8"  height="1" fill="${shell.deep}"/>
  <rect x="30" y="18" width="8"  height="1" fill="${shell.deep}"/>
  <rect x="14" y="28" width="8"  height="1" fill="${shell.deep}"/>
  <rect x="24" y="28" width="8"  height="1" fill="${shell.deep}"/>
  <rect x="34" y="28" width="8"  height="1" fill="${shell.deep}"/>
  <!-- 머리 (작음) -->
  <rect x="4" y="18" width="14" height="14" fill="${skin.shadow}"/>
  <rect x="4" y="18" width="14" height="12" fill="${skin.base}"/>
  <rect x="4" y="18" width="14" height="2"  fill="${skin.light}"/>
  <!-- 눈 -->
  <rect x="6"  y="20" width="4" height="4" fill="#fff"/>
  <rect x="7"  y="21" width="2" height="2" fill="#1a2a00"/>
  <rect x="8"  y="21" width="1" height="1" fill="#fff"/>
  <rect x="12" y="20" width="4" height="4" fill="#fff"/>
  <rect x="13" y="21" width="2" height="2" fill="#1a2a00"/>
  <rect x="14" y="21" width="1" height="1" fill="#fff"/>
  <!-- 코 -->
  <rect x="9" y="27" width="2" height="2" fill="${skin.shadow}"/>
  <!-- 입 (미소) -->
  <rect x="7"  y="29" width="2" height="2" fill="${skin.deep}"/>
  <rect x="13" y="29" width="2" height="2" fill="${skin.deep}"/>
  <!-- 다리 (4개, 짧고 넓적) -->
  <rect x="12" y="42" width="10" height="6" fill="${skin.shadow}"/>
  <rect x="13" y="42" width="8"  height="5" fill="${skin.base}"/>
  <rect x="42" y="42" width="10" height="6" fill="${skin.shadow}"/>
  <rect x="43" y="42" width="8"  height="5" fill="${skin.base}"/>
  <rect x="16" y="44" width="10" height="6" fill="${skin.shadow}"/>
  <rect x="17" y="44" width="8"  height="5" fill="${skin.base}"/>
  <rect x="36" y="44" width="10" height="6" fill="${skin.shadow}"/>
  <rect x="37" y="44" width="8"  height="5" fill="${skin.base}"/>
  <!-- 꼬리 -->
  <rect x="52" y="34" width="6" height="6" fill="${skin.shadow}"/>
  <rect x="53" y="35" width="4" height="4" fill="${skin.base}"/>
</svg>`;
}

function petFish(): string {
  const body = palette5('#3888e0');   // 파란 물고기
  const fin  = palette5('#ff6820');   // 주황 지느러미
  return `
<svg viewBox="0 0 64 56" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges">
  <ellipse cx="32" cy="54" rx="14" ry="2" fill="rgba(0,0,0,0.18)"/>
  <!-- 꼬리 지느러미 -->
  <rect x="48" y="22" width="8"  height="10" fill="${fin.shadow}"/>
  <rect x="50" y="20" width="10" height="8"  fill="${fin.base}"/>
  <rect x="52" y="18" width="8"  height="6"  fill="${fin.light}"/>
  <rect x="48" y="32" width="8"  height="10" fill="${fin.shadow}"/>
  <rect x="50" y="32" width="10" height="8"  fill="${fin.base}"/>
  <!-- 몸통 (타원형) -->
  <rect x="16" y="20" width="36" height="20" fill="${body.shadow}"/>
  <rect x="16" y="20" width="36" height="18" fill="${body.base}"/>
  <rect x="16" y="20" width="36" height="3"  fill="${body.light}"/>
  <!-- 배 (밝은) -->
  <rect x="20" y="30" width="28" height="8" fill="${body.light}"/>
  <rect x="22" y="32" width="24" height="4" fill="${body.rim}"/>
  <!-- 비늘 무늬 -->
  <rect x="22" y="22" width="6" height="4" fill="${body.shadow}"/>
  <rect x="30" y="22" width="6" height="4" fill="${body.shadow}"/>
  <rect x="38" y="22" width="6" height="4" fill="${body.shadow}"/>
  <rect x="26" y="26" width="6" height="4" fill="${body.shadow}"/>
  <rect x="34" y="26" width="6" height="4" fill="${body.shadow}"/>
  <!-- 등 지느러미 -->
  <rect x="26" y="12" width="4" height="10" fill="${fin.shadow}"/>
  <rect x="30" y="10" width="4" height="12" fill="${fin.base}"/>
  <rect x="34" y="12" width="4" height="10" fill="${fin.shadow}"/>
  <!-- 가슴 지느러미 -->
  <rect x="24" y="28" width="6" height="8" fill="${fin.shadow}"/>
  <rect x="25" y="29" width="5" height="6" fill="${fin.base}"/>
  <!-- 머리 -->
  <rect x="8" y="18" width="16" height="18" fill="${body.shadow}"/>
  <rect x="8" y="18" width="16" height="16" fill="${body.base}"/>
  <rect x="8" y="18" width="16" height="2"  fill="${body.light}"/>
  <!-- 눈 (크고 동그랗게) -->
  <rect x="10" y="20" width="8" height="8" fill="#fff"/>
  <rect x="12" y="22" width="4" height="4" fill="#000"/>
  <rect x="13" y="23" width="2" height="2" fill="#fff"/>
  <!-- 입 -->
  <rect x="8"  y="30" width="6" height="3" fill="${body.deep}"/>
  <rect x="9"  y="31" width="4" height="2" fill="#004080"/>
  <!-- 볼터치 -->
  <rect x="10" y="28" width="4" height="2" fill="#ffabc0" opacity="0.6"/>
</svg>`;
}

// ── NEW SPECIES — colored fallbacks ─────────────────────────────────────────

function petColorTinted(baseFn: () => string, _species: string): string {
  // Just use the base species SVG — color differences come from pet ID variations
  return baseFn();
}

// ── RENDERERS MAP ────────────────────────────────────────────────────────────

const RENDERERS: Partial<Record<PetSpecies, () => string>> = {
  dog:     petDog,
  cat:     petCat,
  rabbit:  petRabbit,
  hamster: petHamster,
  dragon:  petDragon,
  bird:    petBird,
  unicorn: petUnicorn,
  penguin: petPenguin,
  fox:     petFox,
  panda:   petPanda,
  bear:    petBear,
  pig:     petPig,
  turtle:  petTurtle,
  fish:    petFish,
  // New species — fallback to closest existing species
  shark:      () => petColorTinted(petFish, 'shark'),
  dolphin:    () => petColorTinted(petFish, 'dolphin'),
  owl:        () => petColorTinted(petBird, 'owl'),
  deer:       () => petColorTinted(petDog, 'deer'),
  sheep:      () => petColorTinted(petHamster, 'sheep'),
  monkey:     () => petColorTinted(petBear, 'monkey'),
  frog:       () => petColorTinted(petTurtle, 'frog'),
  butterfly:  () => petColorTinted(petBird, 'butterfly'),
  ladybug:    () => petColorTinted(petHamster, 'ladybug'),
  elephant:   () => petColorTinted(petPanda, 'elephant'),
  lion:       () => petColorTinted(petBear, 'lion'),
  tiger:      () => petColorTinted(petFox, 'tiger'),
  koala:      () => petColorTinted(petBear, 'koala'),
  raccoon:    () => petColorTinted(petFox, 'raccoon'),
  squirrel:   () => petColorTinted(petHamster, 'squirrel'),
  // 신규 — 기존 베이스 종 매핑 (색감/이름은 pets.ts에서 다양화)
  hedgehog:    () => petColorTinted(petHamster, 'hedgehog'),
  wolf:        () => petColorTinted(petDog, 'wolf'),
  whale:       () => petColorTinted(petFish, 'whale'),
  chick:       () => petColorTinted(petBird, 'chick'),
  ferret:      () => petColorTinted(petFox, 'ferret'),
  alpaca:      () => petColorTinted(petHamster, 'alpaca'),
  capybara:    () => petColorTinted(petHamster, 'capybara'),
  cow:         () => petColorTinted(petPig, 'cow'),
  goat:        () => petColorTinted(petBear, 'goat'),
  crab:        () => petColorTinted(petTurtle, 'crab'),
  bunny_alien: () => petColorTinted(petRabbit, 'bunny_alien'),
  phoenix:     () => petColorTinted(petBird, 'phoenix'),
};

// ─────────────────────────────────────────────────────────────────────────────
// pet_sheet.png frame mapping (6 cols × 30 rows, 128px cells → 768×3840)
//   cols: idle=0, walk=1, sit=2, lie=3, cry=4, cheer=5
// ─────────────────────────────────────────────────────────────────────────────
export type PetAction = 'idle' | 'walk' | 'sit' | 'lie' | 'cry' | 'cheer';

export const PET_SHEET_SPECIES: PetSpecies[] = [
  // 0-3 hand-authored
  'dog', 'cat', 'rabbit', 'hamster',
  // 4-23 quadrupeds (kit-based)
  'fox', 'bear', 'panda', 'wolf', 'tiger', 'lion', 'raccoon', 'squirrel',
  'pig', 'sheep', 'cow', 'deer', 'elephant', 'monkey', 'koala', 'hedgehog',
  'unicorn', 'ferret', 'alpaca', 'capybara',
  // 24-29 specials
  'dragon', 'penguin', 'bird', 'owl', 'butterfly', 'turtle',
];

const SHEET_ROW: Partial<Record<PetSpecies, number>> = Object.fromEntries(
  PET_SHEET_SPECIES.map((sp, i) => [sp, i])
);
const SHEET_COL: Record<PetAction, number> = {
  idle: 0, walk: 1, sit: 2, lie: 3, cry: 4, cheer: 5,
};
export const PET_SHEET_KEY = 'pet_sheet';
export const PET_SHEET_PATH = 'images/pets/pet_sheet.png';
export const PET_SHEET_COLS = 6;
export const PET_SHEET_FRAME = 128;
export const PET_SHEET_ACTIONS: PetAction[] = ['idle', 'walk', 'sit', 'lie', 'cry', 'cheer'];

export const PetRenderer = {
  renderSVG(species: PetSpecies): string {
    const fn = RENDERERS[species];
    if (fn) return fn();
    // Ultimate fallback: dog
    return petDog();
  },

  /**
   * AI 생성 PNG 스프라이트 키 — Phaser cache에서 존재하는지 호출자가 확인.
   * 존재하면 우선 사용, 없으면 SVG로 fallback.
   */
  getSpriteKey(species: PetSpecies): string {
    return `pet_${species}`;
  },

  /** 시트에 포함된 종인지 (dog/cat/rabbit/hamster). */
  hasSheet(species: PetSpecies): boolean {
    return SHEET_ROW[species] !== undefined;
  },

  /** 시트 프레임 index (row*6 + col). */
  getSheetFrame(species: PetSpecies, action: PetAction): number {
    const row = SHEET_ROW[species] ?? 0;
    return row * PET_SHEET_COLS + SHEET_COL[action];
  },

  /** 애니메이션 키 — `pet_<species>_<action>`. */
  getAnimKey(species: PetSpecies, action: PetAction): string {
    return `pet_${species}_${action}`;
  },
};
